import { createFileRoute, Navigate } from '@tanstack/react-router';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import { communicationsSearchSchema } from 'src/modules/shared/schemas/communications-search.schema';
import CommunicationsPage from 'src/modules/communications/components/pages/communications.page';
import { SettingName } from 'src/api/generated';
import { useFeatureFlagSetting } from 'hooks/settings/settings';
import Loading from 'src/modules/shared/components/atoms/loading';
import { COMMUNICATIONS_SMALL_SCREEN_MEDIA_QUERY } from 'src/modules/communications/utils/view-preference.util';

export const Route = createFileRoute('/communications/')({
  component: CommunicationsLayoutComponent,
  staticData: {
    visualViewportMediaQuery: COMMUNICATIONS_SMALL_SCREEN_MEDIA_QUERY,
  },
  validateSearch: (search) => communicationsSearchSchema.parse(search),
});

function CommunicationsLayoutComponent() {
  const { setting: crmActive, loading } = useFeatureFlagSetting(
    SettingName.FEATURE_FLAG_CRM
  );

  if (loading) {
    return <Loading size="lg" />;
  }

  if (!crmActive) {
    return <Navigate to="/calls" />;
  }

  return (
    <AuthenticateRoute>
      <CommunicationsPage />
    </AuthenticateRoute>
  );
}
